import { render, staticRenderFns } from "./BatchView.vue?vue&type=template&id=0854ee96"
import script from "./BatchView.vue?vue&type=script&lang=js"
export * from "./BatchView.vue?vue&type=script&lang=js"
import style0 from "./BatchView.vue?vue&type=style&index=0&id=0854ee96&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3767177327/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0854ee96')) {
      api.createRecord('0854ee96', component.options)
    } else {
      api.reload('0854ee96', component.options)
    }
    module.hot.accept("./BatchView.vue?vue&type=template&id=0854ee96", function () {
      api.rerender('0854ee96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BatchView.vue"
export default component.exports